/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IconButton } from '@fluentui/react/lib/Button';
import { IStackProps, Stack } from '@fluentui/react/lib/Stack';
import React from 'react';
import { CluEntityDetailsWrapper } from 'src/clu/appShell/cluEntityDetailsPage/components/CluEntityDetailsWrapper';
import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { getScopedTheme, getStylistV2 } from 'src/core/themes/luisStylist';

export type CluEditEntityPaneProps = {
    isOpen: boolean;
    onDismiss: () => void;
    entityId: string;
};

const scopedTheme = getScopedTheme('CluEditEntityPane');
const { styleComponent } = getStylistV2('CluEditEntityPane');

/**
 * A component to display and modify an entity's details in a dismissible pane
 */
export const CluEditEntityPane = (props: CluEditEntityPaneProps) => {
    const { isOpen, entityId, onDismiss } = props;
    const { uiStore } = useGlobalState();

    const Pane = styleComponent<IStackProps>(Stack)('Pane', {
        position: 'absolute',
        background: scopedTheme.backgroundColor,
        padding: '60px 30px',
        top: scopedTheme.globalHeaderHeight,
        bottom: 0,
        left: uiStore.isSidebarCollapsed ? scopedTheme.sidebarWidthCollapsed : scopedTheme.sidebarWidthExpanded,
        right: 0,
        overflowY: 'auto',
        overflowX: 'hidden'
    });

    return (
        isOpen && (
            <Pane horizontal horizontalAlign="space-between">
                <CluEntityDetailsWrapper entityName={entityId} />
                <IconButton iconProps={{ iconName: 'ChromeClose' }} onClick={onDismiss} />
            </Pane>
        )
    );
};
